import _axiosRecommends from '../dependencies/_axiosRecommends'

export function publicRecommendsFetchDataApi(params){
  return _axiosRecommends({
    url: '/api/public/recommends',
    timeout: 20000,
    method: 'post',
    responseType: 'json',
    data: params
  })
}

export function publicRecommendsScoreCvsApi(formData){
  return _axiosRecommends({
    url: '/api/public/recommends/cv-score',
    timeout: 30000,
    method: 'post',
    responseType: 'json',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData
  })
}

// M1-703 (video milestone): live on astrnt-dashboard-v2-2 as
// POST /api/public/recommends/interview-question -- stateless, no DB writes.
// Response: { question: { id, prompt }, question_code, answer_constraints:
// { min_duration_sec, max_duration_sec } }. `question.id` is a random UUID for
// UI keying only (nothing is persisted server-side), so the full prompt text
// must be resent to publicRecommendsSubmitInterviewAnswerApi below, not just
// the id. `question_code` is a log-correlation id, also resent there.
// On failure: { success: false, error }, with 422 for a missing skill, 429
// (+ Retry-After header) for rate limiting, 503 if the AI generation fails.
export function publicRecommendsGenerateInterviewApi(params){
  return _axiosRecommends({
    url: '/api/public/recommends/interview-question',
    timeout: 20000,
    method: 'post',
    responseType: 'json',
    data: params // { skill, job_title }
  })
}

// M1-703 (video milestone): live as POST /api/public/recommends/interview-answer.
// Stateless -- transcribes the video and scores it in the same request, no
// signup/session step. Response: { success: true, transcript, result: { rubric:
// [{ criterion, tier, description }], justification } }. On failure:
// { success: false, error }, with 422 for a too-short/silent/invalid recording,
// 413 if it's too large, 429 for rate limiting, 503 if transcription/scoring fails.
export function publicRecommendsSubmitInterviewAnswerApi(formData){
  return _axiosRecommends({
    url: '/api/public/recommends/interview-answer',
    timeout: 60000,
    method: 'post',
    responseType: 'json',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData // fields: video, skill, job_title, question_text, question_code
  })
}
